const print3461Form = [
  {
    name: 'form3461Date',
    label: 'Date',
    type: 'date',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: true,
    disabled: false,
    icon: undefined,
    sizeProp: { xs: 12, sm: 12, md: 12 }
  },
]

const optionsMap = {

}

export { optionsMap, print3461Form }
